import React from 'react'

import googleImg from '../img/googleStoreImage.png'
import appleImg from '../img/iOSStoreImage.png'

const StoreLinks = ({androidStoreLink, iOSStoreLink, leanpubLink, amazonLink , title}) => <div className="store-links">
  { iOSStoreLink &&
    <a href={iOSStoreLink}><img src={appleImg} alt={`Download ${title} from Apple App Store`} style={{width: 135, height: 40}}/></a>}
  
  { androidStoreLink &&
    <a href={androidStoreLink}><img src={googleImg} alt={`Download ${title} from Google Play`} style={{ width: 135, height: 40}}/></a>}
    
  { leanpubLink &&
    <a href={leanpubLink} alt={`${title}`}><div className="webLink">On Leanpub</div></a>}

  { amazonLink  &&
    <a href={amazonLink} alt={`${title}`}><div className="webLink">On Kindle</div></a>}
</div>

export default StoreLinks;


// WEBPACK FOOTER //
// ./src/components/storeLinks.js